import { Column, Badge } from '@synqo/frontend-component-library';
import type { ApiCashJournal, EnumProcessState } from '@Model';
import { processStateOptions, getBadgeVariantByProcessState, getEnumProcessStateLabel } from '@Model';

export const cashJournalColumns: Column<ApiCashJournal>[] = [
    { name: 'date', label: 'Datum', type: 'date', filterVariant: 'day-range' },
    { name: 'number', label: 'Nummer' },
    { name: 'start_value', label: 'Anfangsbestand', type: 'currency' },
    { name: 'end_value', label: 'Endbestand', type: 'currency' },
    {
        name: 'process_state',
        label: 'Status',
        filterVariant: 'select',
        filterOptions: processStateOptions,
        renderCell: ({ cellData }) => (
            <Badge variant={getBadgeVariantByProcessState(cellData as EnumProcessState)}>
                {getEnumProcessStateLabel(cellData as EnumProcessState)}
            </Badge>
        ),
    },
    { name: 'cash_register.display_string', label: 'Kasse' },
];
